<template>
  <f7-page
    class="tamtamMessagePage"
    infinite
    infinite-top
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore"
  >
    <f7-navbar
      :back-link="navbarShowBackLink"
      sliding
      no-shadow
      class="tamtamNav"
      v-if="showNavbar"
    >
      <f7-nav-left
        class="navBarLeftImg"
        @click="openContactDetailPanel()"
        href="#"
      >
        <img
          class="tamtamBadge"
          v-if="navbarAvatarSrc !== null"
          :src="`${navbarAvatarSrc}`"
        />
        <f7-badge v-else color="auto" class="tamtamBadge"
          >{{ $filtersGetInitial.getInitial(navbarAvatarInitial) }}
        </f7-badge>
      </f7-nav-left>
      <f7-nav-title class="title margin-left">
        <span
          class="grid gris-rows-2"
          v-if="isPersonalRoute && counterPartUser"
        >
          <span class="group_title">{{ navbarTitleName }}</span>
          <small
            class="userOnlineSratus color-primary"
            style="font-size: small; color: auto"
            v-if="
              counterPartUser.online &&
              (typingMessage === '' || !typingMessage.typing)
            "
            >{{ $t("tamtammessage.online") }}</small
          >
          <small
            class="userOnlineSratus"
            v-else-if="
              !counterPartUser.online &&
              (typingMessage === '' || !typingMessage.typing)
            "
            style="font-size: small"
            >{{ $t("tamtammessage.online") }}
            {{ $dayjs().to($dayjs(counterPartUser.timeOffline)) }}</small
          >
          <small
            class="userIsTypingMessage"
            style="font-size: small; color: var(--f7-theme-color)"
            v-else-if="typingMessage.typing"
            >{{
              $t("tamtam.isTyping", {
                isTyping: `${typingMessage.name}`,
              })
            }}</small
          >
        </span>
        <span class="grid gris-rows-2" v-if="isGroupRoute && group !== null">
          <span class="group_title"> {{ group.name }} </span>
          <small
            class="group_users"
            style="font-size: small"
            v-if="typingMessage === '' || !typingMessage.typing"
            >{{ chatGroupUserList }}</small
          >
          <small
            class="userIsTypingMessage"
            style="font-size: small; color: var(--f7-theme-color)"
            v-if="typingMessage.typing"
            >{{
              $t("tamtam.isTyping", {
                isTyping: `${typingMessage.name}`,
              })
            }}</small
          >
        </span>
        <span v-if="isInfoRoute && counterPartUser">{{
          counterPartUser.name
        }}</span>
      </f7-nav-title>

      <f7-nav-right>
        <f7-link
          v-if="isTablet"
          class="searchbar-enable"
          data-searchbar=".searchbar-message"
          icon-ios="f7:search_strong"
          icon-md="material:search"
        ></f7-link>
        <f7-link
          :class="!isTablet ? 'no-margin-left' : ''"
          popover-open=".otherActions"
          icon-ios="f7:ellipsis_vertical"
          icon-md="material:more_vert"
        ></f7-link>
      </f7-nav-right>

      <f7-searchbar
        class="searchbar-message"
        expandable
        search-container=".messages-list"
        search-item=".messages.message"
        search-in=".message-text, .message-name, .message-footer, .message-title, message-text-footer"
        :clear-button="true"
        :backdrop="false"
      ></f7-searchbar>
    </f7-navbar>

    <f7-navbar
      v-if="!isTablet && selectedMessages && selectedMessages.length > 0"
      top
      no-shadow
      :class="'messageOptionsNavBar' + messageInScope.id"
    >
      <f7-nav-left v-if="selectedMessages.length > 1 || messageIsSelected">
        <f7-link
          @click="clearSelection()"
          icon-ios="f7:xmark"
          icon-md="material:clear"
        >
        </f7-link>
        <a v-if="selectedMessages.length > 1">
          {{ selectedMessages.length }}
        </a>
      </f7-nav-left>
      <f7-nav-right v-if="selectedMessages.length > 1 || messageIsSelected">
        <f7-link
          v-if="selectedMessages.length > 1"
          icon-ios="f7:trash"
          icon-md="material:delete"
          icon-color="red"
          @click="deleteSelectedMsg()"
        ></f7-link>
        <f7-link
          v-if="selectedMessages.length > 1"
          :disabled="selectedMessages.length === 0"
          icon-ios="f7:arrowshape_turn_up_right"
          icon-md="material:reply"
          :style="theme.md ? 'transform:  scaleX(-1)' : ''"
          icon-color="gray"
          @click="forwardAllMsg()"
        ></f7-link>
      </f7-nav-right>
      <f7-link
        v-if="
          messageInScope.groupType !== 'PERSONAL' &&
          selectedMessages.length <= 1
        "
        icon-ios="f7:arrowshape_turn_up_left_2"
        icon-md="material:reply_all"
        @click="replyMsg(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="
          messageInScope.groupType === 'PERSONAL' &&
          selectedMessages.length <= 1
        "
        icon-ios="f7:arrowshape_turn_up_left"
        icon-md="material:reply"
        icon-color="lightblue"
        @click="replyMsg(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="
          messageInScope.groupType !== 'PERSONAL' &&
          !isOwnMessage(messageInScope) &&
          selectedMessages.length <= 1
        "
        icon-ios="f7:arrowshape_turn_up_left"
        icon-md="material:reply"
        icon-color="teal"
        @click="replyMsgPrivately(messageInScope)"
      ></f7-link>

      <f7-link
        v-if="selectedMessages.length <= 1"
        icon-ios="f7:trash"
        icon-md="material:delete"
        icon-color="orange"
        @click="deleteForMe(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="
          isOwnMessage(messageInScope) &&
          selectedMessages.length <= 1
        "
        icon-color="red"
        icon-ios="f7:trash_slash"
        icon-md="material:delete_forever"
        @click="deleteForAll(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="
          isOwnMessage(messageInScope) &&
          selectedMessages.length <= 1
        "
        icon-color="blue"
        icon-ios="f7:pencil"
        icon-md="material:edit"
        @click="handleEditMessage(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="selectedMessages.length <= 1"
        icon-color="deeppurple"
        icon-ios="f7:square_list"
        icon-md="material:playlist_add_check"
        @click="selectMsg(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="selectedMessages.length <= 1"
        icon-color="lime"
        icon-ios="f7:square_on_square"
        icon-md="material:content_copy"
        class="margin-right-half"
        @click="copyMsg(messageInScope)"
      ></f7-link>
      <f7-link
        v-if="selectedMessages.length <= 1"
        icon-ios="f7:arrowshape_turn_up_right"
        icon-md="material:reply"
        :style="theme.md ? 'transform:  scaleX(-1)' : ''"
        icon-color="gray"
        @click="forwardMsg(messageInScope)"
      >
      </f7-link>
    </f7-navbar>

    <f7-messagebar
      :style="
        selectedMessages.length >= 1 && isTablet
          ? 'display:none'
          : 'display:block'
      "
      :placeholder="placeholder"
      ref="messagebarRef"
      :attachments-visible="attachmentsVisible"
      :sheet-visible="sheetVisible"
      :value="messageText"
      @input="messageText = $event.target.value"
      @keypress.enter="sendMessage()"
      @messagebar:focus="startTyping()"
      @messagebar:change="startTyping()"
      @keydown="
        handleMentionKeydown($event);
        startTyping();
      "
      @keyup="stopTyping()"
      @messagebar:blur="onMessagebarBlur()"
      @keypress.native="startTyping()"
      @keydown.native="startTyping()"
      @keyup.native="stopTyping()"
      @paste="onPaste"
    >
      <template #inner-start>
        <f7-link
          v-if="isTablet && !isRecording"
          icon-ios="f7:paperclip"
          icon-size="24"
          icon-md="material:attachment"
          class="attachFileButton"
          @click="attachFileOpenActions()"
        ></f7-link>
        <f7-link
          icon-ios="f7:smiley"
          icon-md="material:insert_emoticon"
          @click="toogleDialogEmoji()"
        ></f7-link>
      </template>
      <template #inner-end>
        <f7-link
          v-if="!isRecording && attachments.length == 0 && !isTablet"
          icon-ios="f7:paperclip"
          icon-size="24"
          icon-md="material:attachment"
          class="attachFileButton"
          @click="attachFileOpenActions()"
        >
        </f7-link>
        <f7-link
          v-if="!isRecording && messageText === '' && attachments.length == 0"
          icon-ios="f7:mic_circle_fill"
          class="recordBtn"
          icon-md="material:mic"
          :aria-label="$t('tamtammessage.startRecording')"
          @click="startAudioRecording()"
        ></f7-link>
        <span v-if="isRecording" class="recording-indicator">
          <span class="recording-dot"></span>
          {{ formattedRecordingDuration }}
        </span>
        <f7-link
          v-if="isRecording"
          icon-ios="f7:stop_circle_fill"
          icon-md="material:stop"
          icon-color="white"
          class="recordBtn stop"
          :aria-label="$t('tamtammessage.stopRecording')"
          @click="stopAudioRecording()"
          ref="stopRecord"
        >
        </f7-link>

        <f7-link
          v-if="editingMessage && (messageText !== '')"
          icon-ios="f7:checkmark_circle_fill"
          icon-md="material:check_circle"
          @click="saveEdit"
        ></f7-link>
        <f7-link
          v-else-if="messageText !== '' || (attachments && attachments.length > 0)"
          icon-ios="f7:arrow_up_circle_fill"
          icon-md="material:send"
          @click="sendMessage"
        ></f7-link>
      </template>

      <template #before-area>
        <input
          type="file"
          multiple
          name="file"
          id="fileInput"
          style="display: none"
          @change="onChange"
          ref="file"
          accept="*"
        />
        <div
          v-if="editingMessage"
          class="edit-preview"
        >
          <div class="edit-preview-bar"></div>
          <span class="edit-preview-label">{{ $t('tamtammessage.editMessage') }}</span>
          <span class="edit-preview-text">{{ editingMessage.text }}</span>
          <f7-link
            @click.stop="cancelEdit()"
            class="edit-preview-close"
            icon-ios="f7:multiply"
            icon-md="material:clear"
            icon-size="16"
            icon-color="gray"
          ></f7-link>
        </div>
        <div
          v-if="replyMessage && replyMessage.id"
          class="reply-preview"
          role="button"
          tabindex="0"
          @click="scrollToMessage(replyMessage.id)"
          @keydown.enter="scrollToMessage(replyMessage.id)"
          @keydown.space.prevent="scrollToMessage(replyMessage.id)"
        >
          <div class="reply-preview-bar"></div>
          <span class="reply-preview-name">{{ replyMessage.senderName }}</span>
          <div
            class="reply-preview-content"
            :class="
              replyMessage.attachment && replyMessage.text
                ? 'cols40_60'
                : 'cols100'
            "
          >
            <div v-if="replyMessage.attachment" class="reply-preview-thumb">
              <img
                v-if="replyMessage.image"
                :src="replyMessage.attachment"
                :alt="replyMessage.fileName || ''"
              />
              <video v-else-if="replyMessage.video" controls>
                <source
                  :src="replyMessage.attachment"
                  :type="replyMessage.contentType"
                  :alt="replyMessage.fileName"
                  loading="lazy"
                />
              </video>
              <audio v-else-if="replyMessage.audio" controls>
                <source
                  :src="replyMessage.attachment"
                  :type="replyMessage.contentType"
                  :alt="replyMessage.fileName"
                  loading="lazy"
                />
              </audio>
              <i v-else class="f7-icons color-gray">doc_text</i>
            </div>
            <div class="reply-preview-info" v-else-if="replyMessage.text">
              <!-- <span v-if="replyMessage.text" class="reply-preview-text">
                <i class="f7-icons size-14">paperclip</i> {{ replyMessage.fileName || $t('tamtammessage.attachment') }}
              </span> -->
              <span class="reply-preview-text">{{ replyMessage.text }}</span>
            </div>
          </div>
          <f7-link
            @click.stop="removeReplyMessage()"
class="reply-preview-close"
          icon-ios="f7:multiply"
          icon-md="material:clear"
          icon-size="16"
          icon-color="gray"
        >
          </f7-link>
        </div>
      </template>
 <template #default>
      <f7-messagebar-attachments
        class="dropzone-container"
        :class="{ 'is-dragging': isDragging }"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
      >
<template #default>
          <f7-photo-browser
              ref="attachPopup"
              v-if="
                documentsUrl &&
                documentsUrl.length > 0 &&
                photoList &&
                photoList.length
              "
              :photos="photoList"
              :thumbs="photoList"
              type="popup"
            />
            <f7-messagebar-attachment
              @attachment:delete="deleteAttachment(attachment)"
              v-for="(attachment, index) in documentsUrl"
              :key="attachment.fileId || attachment.fileName || index"
            >
              <template #default>
                <a
                  href="#"
                  @click.prevent="$refs.attachPopup.open()"
                  class="attachment-preview"
                  v-if="attachment.fileType === 'image'"
                >
                  <img
                    :src="attachment.url"
                    :alt="attachment.fileName || attachment.name"
                    loading="lazy"
                  />
                </a>
                <a
                  href="#"
                  @click.prevent="$refs.attachPopup.open()"
                  class="attachment-preview"
                  v-else-if="attachment.fileType === 'video'"
                >
                  <video
                    :src="attachment.url"
                    :type="attachment.contentType"
                    preload="metadata"
                    muted
                    playsinline
                  ></video>
                  <span class="play-badge"
                    ><i class="f7-icons">play_fill</i></span
                  >
                </a>
                <a
                  href="#"
                  @click.prevent="$refs.attachPopup.open()"
                  class="attachment-preview attachment-preview--file"
                  v-else-if="attachment.fileType === 'audio'"
                >
                  <span class="attachment-preview-icon"
                    ><i class="f7-icons">music_note</i></span
                  >
                  <span class="attachment-preview-name">{{
                    attachment.fileName || attachment.name
                  }}</span>
                  <span class="attachment-preview-size">{{
                    formatFileSize(attachment.size)
                  }}</span>
                </a>
                <a
                  href="#"
                  @click.prevent="$refs.attachPopup.open()"
                  class="attachment-preview attachment-preview--file"
                  v-else-if="attachment.contentType === 'application/pdf'"
                >
                  <span
                    class="doc-icon"
                    v-html="getFileMimeType(attachment).icon"
                  ></span>
                  <span class="attachment-preview-name">{{
                    attachment.fileName || attachment.name
                  }}</span>
                  <span class="attachment-preview-size"
                    >PDF · {{ formatFileSize(attachment.size) }}</span
                  >
                </a>
                <a
                  href="#"
                  @click.prevent="openFileWithFileOpener(attachment)"
                  class="attachment-preview attachment-preview--file"
                  v-else
                >
                  <span
                    class="doc-icon"
                    v-html="getFileMimeType(attachment).icon"
                  ></span>
                  <span class="attachment-preview-name">{{
                    attachment.fileName || attachment.name
                  }}</span>
                  <span class="attachment-preview-size">{{
                    formatFileSize(attachment.size)
                  }}</span>
                </a>

                <f7-link class="messagebar-attachment-edit"
                  v-if="attachment.fileType === 'image'"
                  icon-f7="pencil_circle"
                  @click="editImage(attachment)"
                ></f7-link>
              </template>
            </f7-messagebar-attachment>
        </template>
      </f7-messagebar-attachments>
    </template>
      <template #after-inner>
        <f7-messagebar-sheet :sheet-visible="sheetVisible">
          <Picker
            @select="onSelectEmoji"
            :data="emojiIndex"
            :set="getSet"
            :emojiSize="emojisize"
            :showPreview="false"
            color="var(--f7-theme-color)"
            :i18n="i18n_locale"
          />
        </f7-messagebar-sheet>
      </template>
      <template #before-inner>
        <div>
        <div
          v-if="mentionQuery !== null && filteredMentionUsers.length > 0"
          class="mention-dropdown"
        >
            <div
              v-for="(user, idx) in filteredMentionUsers"
              :key="user.userId"
              class="mention-item"
              :class="{ 'mention-item-active': idx === mentionActiveIndex }"
              role="button"
              tabindex="0"
              @click="insertMention(user)"
              @keydown.enter="insertMention(user)"
              @keydown.space.prevent="insertMention(user)"
            >
              <div class="mention-item-avatar">
                <img
                  v-if="user.logo || user.avatar"
                  :src="user.logo || user.avatar"
                  :alt="user.name"
                />
                <span v-else>{{ $filtersGetInitial.getInitial(user.name) }}</span>
              </div>
              <div class="mention-item-info">
                <span class="mention-item-name">{{ user.name }}</span>
                <span class="mention-item-handle" v-if="user.username"
                  >@{{ user.username || user.tag }}</span
                >
              </div>
            </div>
          </div>
          <span class="display-flex" style="justify-content: center">
            <Picker
              @select="onSelectEmoji"
              :data="emojiIndex"
              :set="getSet"
              v-if="showDialog && isTablet"
              :emojiSize="emojisize"
              :showPreview="false"
              color="var(--f7-theme-color)"
              :i18n="i18n_locale"
            /> </span>
            </div>
      </template>
    </f7-messagebar>
    <f7-messages
      ref="messages"
      :init="false"
      class="searchbar-found messages-list"
      v-if="f7route.params.type === 'undefined' && infoMessage.length > 0"
    >
      <f7-message
        v-for="(message, index) in infoMessage"
        :key="index"
        :type="message.id === null ? 'received' : 'sent'"
        :image="message.image"
        :avatar="
          message.senderName === 'avo¢hat' && message.type === 'received'
            ? 'https://avocash.com/24x24.svg'
            : chatUser.avatar !== null
            ? `${chatUser.avatar}`
            : null
        "
        :name="isOwnMessage(message) ? '' : message.senderName"
        :first="isFirstMessage(infoMessage, message, index)"
        :last="isLastMessage(infoMessage, message, index)"
        :tail="isLastMessage(infoMessage, message, index)"
        @click:header="acceptInvitation(message)"
        @click:footer="rejectInvitation(message)"
      >
        <template #text>
          <span
            v-if="message.text"
            v-html="renderMentions(message.text)"
          ></span>
        </template>
        <template #text-footer>
          <span>
            {{ $dayjs(new Date(message.sentAt)).format("HH:mm") }}
          </span>
        </template>
      </f7-message>
      <f7-message
        v-if="typingMessage"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :header="$t('tamtam.isTyping', { isTyping: `${typingMessage.name}` })"
        :avatar="typingMessage.avatar"
      >
      </f7-message>
    </f7-messages>
    <f7-messages
      ref="messages"
      :init="false"
      class="searchbar-found messages-list mainMessages"
      v-if="messagesData"
    >
      <span
        v-for="(dayMessages, messageDate, index) in messagesData"
        :key="index"
        class="messages"
      >
        <f7-messages-title
          style="position: -webkit-sticky; position: sticky; top: 20px"
          ><b>{{ messageDate }}</b>
        </f7-messages-title>
        <span
          v-for="(message, index) in dayMessages"
          :key="index"
          href="#"
          :class="
            'messages margin-top-half tapHoldRemoveLinks selectedMsg selectedMsgClass' +
            message.id
          "
        >
          <f7-messages-title v-if="message.type === 'title'"
            ><b
              >{{ $dayjs(new Date(message.sentAt)).format("HH:mm") }}
              {{ message.text }}</b
            >
          </f7-messages-title>
          <f7-message
            v-if="
              message.userMessageStatus &&
              message.userMessageStatus.length > 0 &&
              message.userMessageStatus.find((x) => x.status === 'deleted') &&
              message.userMessageStatus.find((x) => isOwnUserId(x.userId)) &&
              message.userMessageStatus.find((x) => isOwnUserId(x.userId))
                .status === 'deleted' &&
              message.type !== 'title'
            "
            :avatar="
              !isOwnMessage(message) &&
              counterPartUser.avatar !== null
                ? `${counterPartUser.avatar}`
                : null
            "
            :id="message.id"
            :type="isOwnMessage(message) ? 'sent' : 'received'"
            :name="
              isOwnMessage(message) ||
              message.groupType === 'PERSONAL'
                ? ''
                : message.senderName
            "
            :first="isFirstMessage(dayMessages, message, index)"
            :last="isLastMessage(dayMessages, message, index)"
            :tail="isLastMessage(dayMessages, message, index)"
            @taphold="handleMessageActions(message)"
            :class="`message_${message.id}`"
          >
            <template #text>
              <span
                style="font-style: italic"
                v-if="
                  message.userMessageStatus &&
                  message.userMessageStatus.length > 0 &&
                  message.userMessageStatus.find(
                    (x) => isOwnUserId(x.deletedBy),
                  )
                "
                >{{ $t("tamtammessage.youDeletedThisMessage") }}</span
              >
              <span style="font-style: italic" v-else>{{
                $t("tamtammessage.messageDeleted")
              }}</span></template
            >
            <template #text-footer>
              <span>
                {{ $dayjs(new Date(message.sentAt)).format("HH:mm") }}
              </span></template
            >
          </f7-message>
          <label
            class="checkbox selectableMsg"
            v-if="
              message.type !== 'title' &&
              (message.status !== 'deleted' ||
                (message.userMessageStatus &&
                  message.userMessageStatus.length > 0 &&
                  !message.userMessageStatus.find(
                    (x) => x.status === 'deleted',
                  )))
            "
            :style="{
              'padding-left': isOwnMessage(message) ? '16px' : '32px',
              position: 'absolute',
              left: !f7.support.touch ? '40px' : '',
              top: '50%',
              '-ms-transform': 'translateY(-50%)',
              transform: 'translateY(-50%)',
              display:
                !f7.support.touch && !messageIsSelected ? 'none' : 'block',
            }"
          >
            <input
              @change="selectMessage(message)"
              type="checkbox"
              :value="message.id"
              v-if="selectedMessages && selectedMessages.length > 0"
              :checked="
                selectedMessages.findIndex((x) => x.id === message.id) >= 0
              "
              :name="'checkbox' + message.id"
            />
            <i class="icon-checkbox" v-if="f7.support.touch == false"></i>
          </label>

          <f7-message
            v-if="message.type === 'feed_card' && message.type !== 'title'"
            :id="message.id"
            :type="message.type"
            :name="
              isOwnMessage(message) ||
              message.groupType === 'PERSONAL'
                ? ''
                : message.senderName
            "
            :first="isFirstMessage(dayMessages, message, index)"
            :last="isLastMessage(dayMessages, message, index)"
            :tail="isLastMessage(dayMessages, message, index)"
            @taphold="handleMessageActions(message)"
            @click="(e) => handleTapMessage(message, e)"
            :class="'message_' + message.id"
          >
            <template #image>
              <ChatFeedCard :feedCard="message.feedCard" />
            </template>
            <template #text-footer>
              <span style="font-size: 100%">
                <span
                  class="margin-right-half"
                  :style="{
                    color: isOwnMessage(message) ? 'white' : '',
                    'font-size': '80%',
                  }"
                >
                  {{ $dayjs(new Date(message.sentAt)).format("HH:mm") }}
                </span>
                <span
                  v-if="isMessageEdited(message)"
                  class="message-edited-tag"
                  :style="{
                    color: isOwnMessage(message) ? 'rgba(255,255,255,0.7)' : 'inherit',
                    'font-size': '75%',
                    opacity: 0.7,
                  }"
                >{{ $t('tamtammessage.edited') }}</span>
                <span
                  v-if="
                    isOwnMessage(message) &&
                    message.userMessageStatus &&
                    message.userMessageStatus.length > 0
                  "
                >
                  <f7-icon
                    ios="material:done"
                    md="material:done"
                    v-if="
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      )?.status === 'sent'
                    "
                    color="gray"
                    bg-color="white"
                    style="
                      border-radius: 50%;
                      font-size: 80%;
                      opacity: 1;
                      background-color: var(--f7-message-sent-text-color);
                    "
                  >
                  </f7-icon>
                  <f7-icon
                    ios="material:done_all"
                    md="material:done_all"
                    v-if="
                      message.groupType === 'PERSONAL' &&
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      )?.status === 'read'
                    "
                    style="
                      border-radius: 50%;
                      font-size: 80%;
                      opacity: 1;
                      background-color: var(--f7-message-sent-text-color);
                    "
                    color="auto"
                  ></f7-icon>
                </span>
              </span>
            </template>
            <template #end>
              <span
                v-if="!f7.support.touch"
                :class="'targetIcon' + message.id"
              ></span>
              <span
                class="popoverActionIcon"
                v-if="f7.device.desktop"
                :class="'targetIcon' + message.id"
              >
                <f7-link
                  class="message-menu-icon"
                  @click="openMessageOpenActions(message)"
                  icon-ios="f7:chevron_down"
                  icon-md="material:expand_more"
                ></f7-link>
              </span>
            </template>
          </f7-message>

          <f7-message
            v-if="
              message.msgType !== 'feed_card' &&
              message.userMessageStatus &&
              message.userMessageStatus.length > 0 &&
              !message.userMessageStatus.find((x) => x.status === 'deleted') &&
              message.type !== 'title'
            "
            :avatar="
              !isOwnMessage(message) &&
              counterPartUser.avatar !== null
                ? `${counterPartUser.avatar}`
                : null
            "
            :id="message.id"
            :type="isOwnMessage(message) ? 'sent' : 'received'"
            :name="
              isOwnMessage(message) ||
              message.groupType === 'PERSONAL'
                ? ''
                : message.senderName
            "
            :first="isFirstMessage(dayMessages, message, index)"
            :last="isLastMessage(dayMessages, message, index)"
            :tail="isLastMessage(dayMessages, message, index)"
            @taphold="handleMessageActions(message)"
            @click="(e) => handleTapMessage(message, e)"
            :class="`message_${message.id}`"
          >
            <template
              #image
              v-if="message.attachments && message.attachments.length > 0"
            >
              <div class="attachment-block">
                <div
                  v-if="imageAttachments(message.attachments).length"
                  class="attachment-grid"
                  :class="
                    imageAttachments(message.attachments).length === 1
                      ? 'attachment-grid--single'
                      : 'attachment-grid--multi'
                  "
                  role="button"
                  tabindex="0"
                  @click="messagePhotoBrowser(message)"
                  @keydown.enter="messagePhotoBrowser(message)"
                  @keydown.space.prevent="messagePhotoBrowser(message)"
                >
                  <f7-link
                    v-for="(item, itemIndex) in imageAttachments(
                      message.attachments,
                    ).slice(0, 4)"
                    :key="item.fileId || item.id || item.url"
                    class="media-thumb media-image"
                    @click.stop="messagePhotoBrowser(message)"
                  >
                    <img
                      :src="item.url"
                      :alt="item.alt || item.fileName"
                      loading="lazy"
                    />
                    <span
                      v-if="
                        itemIndex === 3 &&
                        imageAttachments(message.attachments).length > 4
                      "
                      class="media-more-indicator"
                    >
                      +{{ imageAttachments(message.attachments).length - 4 }}
                    </span>
                  </f7-link>
                </div>

                <div
                  v-if="videoAttachments(message.attachments).length"
                  class="attachment-grid"
                  :class="
                    videoAttachments(message.attachments).length === 1
                      ? 'attachment-grid--single'
                      : 'attachment-grid--multi'
                  "
                >
                  <f7-link
                    v-for="(item, itemIndex) in videoAttachments(
                      message.attachments
                    ).slice(0, 4)"

                    :key="item.fileId || item.id || item.url"
                    class="media-thumb media-video"
                    @click.stop="messagePhotoBrowser(message)"
                  >
                    <!-- <span class="media-preview">
                      <span class="media-preview-icon"><i class="f7-icons">videocam_fill</i></span>
                      <span class="play-badge"><i class="f7-icons">play_fill</i></span>
                    </span>
                    <span class="media-meta">
                      <span class="media-title">{{ item.fileName }}</span>
                      <span class="media-subtitle">{{ formatFileSize(item.size) }}</span>
                    </span> -->
                    <video v-if="item.url" controls>
                      <source
                        :src="item.url"
                        :type="item.contentType || 'video/mp4'"
                        :alt="item.alt || item.fileName"
                        loading="lazy"
                      />
                    </video>
                    <span
                      v-if="
                        itemIndex === 3 &&
                        videoAttachments(message.attachments).length > 4
                      "
                      class="media-more-indicator"
                    >
                      +{{ videoAttachments(message.attachments).length - 4 }}
                    </span>
                  </f7-link>
                </div>

                <div
                  v-if="audioAttachments(message.attachments).length"
                  class="attachment-list"
                >
                  <f7-link
                    v-for="item in audioAttachments(message.attachments)"
                    :key="item.fileId || item.id || item.url"
                    type="button"
                    class="media-row media-audio"
                    @click.stop="messagePhotoBrowser(message)"
                  >
                    <span class="media-preview media-preview--audio">
                      <i class="f7-icons">music_note</i>
                    </span>
                    <span class="media-meta">
                      <span class="media-title">{{ item.fileName }}</span>
                      <span class="media-subtitle">{{
                        formatFileSize(item.size)
                      }}</span>
                    </span>
                  </f7-link>
                </div>

                <div
                  v-if="documentAttachments(message.attachments).length"
                  class="attachment-list"
                >
                  <f7-link
                    v-for="item in documentAttachments(message.attachments)"
                    :key="item.fileId || item.id || item.url"
                    type="button"
                    class="media-row media-document"
                    @click.stop="openFileWithFileOpener(item)"
                  >
                    <span
                      class="doc-icon"
                      v-html="getFileMimeType(item).icon"
                    ></span>
                    <span class="media-meta">
                      <span class="media-title">{{ item.fileName }}</span>
                      <span class="media-subtitle">{{
                        formatFileSize(item.size)
                      }}</span>
                    </span>
                    <span class="download-hint">
                      <i class="f7-icons">square_arrow_down</i>
                    </span>
                  </f7-link>
                </div>
              </div>
            </template>
            <template #text v-if="message.text" class="message-text">
              <span v-html="renderMentions(message.text)"> </span>
            </template>
            <template #text-footer>
              <span style="font-size: 100%">
                <span
                  class="margin-right-half"
                  :style="{
                    color: isOwnMessage(message) ? 'white' : '',
                    'font-size': '80%',
                  }"
                >
                  {{ $dayjs(new Date(message.sentAt)).format("HH:mm") }}</span
                >
                <span
                  v-if="isMessageEdited(message)"
                  class="message-edited-tag"
                  :style="{
                    color: isOwnMessage(message) ? 'rgba(255,255,255,0.7)' : 'inherit',
                    'font-size': '75%',
                    opacity: 0.7,
                  }"
                >{{ $t('tamtammessage.edited') }}</span>
                <span
                  v-if="
                    isOwnMessage(message) &&
                    message.userMessageStatus &&
                    message.userMessageStatus.length > 0
                  "
                >
                  <f7-icon
                    ios="material:done"
                    md="material:done"
                    v-if="
                      message.userMessageStatus &&
                      message.userMessageStatus.length > 0 &&
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      ) &&
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      ).status === 'sent'
                    "
                    color="gray"
                    bg-color="white"
                    style="
                      border-radius: 50%;
                      font-size: 80%;
                      opacity: 1;
                      background-color: var(--f7-message-sent-text-color);
                    "
                  ></f7-icon>
                  <f7-icon
                    ios="material:done_all"
                    md="material:done_all"
                    v-if="
                      message.groupType === 'PERSONAL' &&
                      message.userMessageStatus &&
                      message.userMessageStatus.length > 0 &&
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      ) &&
                      message.userMessageStatus.find(
                        (x) => isOwnUserId(x.userId),
                      ).status === 'read'
                    "
                    style="
                      border-radius: 50%;
                      font-size: 80%;
                      opacity: 1;
                      background-color: var(--f7-message-sent-text-color);
                    "
                    color="auto"
                  ></f7-icon>
                </span>
              </span>
            </template>
            <template #end>
              <span
                v-if=" f7.support.touch"
                :class="'targetIcon' + message.id"
              ></span>
              <span
                class="popoverActionIcon"
                v-if="f7.device.desktop"
                :class="'targetIcon' + message.id"
              >
                <f7-link
                  class="message-menu-icon"
                  @click="openMessageOpenActions(message)"
                  icon-ios="f7:chevron_down"
                  icon-md="material:expand_more"
                ></f7-link>
              </span>
            </template>
          </f7-message>
          <span class="message-reactions-wrapper">
            <f7-link
              class="message-reactions"
              v-if="message.reactions && message.reactions.length > 0"
              :class="
                isOwnMessage(message)
                  ? 'message-sent'
                  : 'message-received message-received-reactions'
              "
              style="font-size: 14px; text-decoration: none; color: inherit"
              @click="showMessageReactions(message)"
              :text="`${message.reactions
                .map((x) => x.emoji)
                .join('')} ${message.reactions.reduce(
                (sum, x) => sum + x.count,
                0,
              )}`"
            ></f7-link>
          </span>
        </span>
      </span>
      <f7-message
        v-if="typingMessage && typingMessage.name"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :header="$t('tamtam.isTyping', { isTyping: `${typingMessage.name}` })"
        :avatar="typingMessage.avatar"
      >
      </f7-message>
    </f7-messages>
    <f7-toolbar
      v-if="isTablet && selectedMessages && selectedMessages.length > 0"
      bottom
      no-shadow
      class="multiMessagesSelect"
    >
      <f7-link
        icon-ios="f7:xmark"
        icon-md="material:clear"
        :text="
          selectedMessages.length + ' ' + $t('tamtammessage.selectedMessages')
        "
        style="text-transform: lowercase"
        text-color="gray"
        @click="clearSelection()"
      ></f7-link>
      <f7-link
        :disabled="selectedMessages.length == 0"
        icon-ios="f7:trash"
        icon-md="material:delete"
        icon-color="red"
        @click="deleteSelectedMsg()"
      ></f7-link>
      <f7-link
        :disabled="selectedMessages.length === 0"
        icon-ios="f7:arrowshape_turn_up_right"
        icon-md="material:reply"
        :style="theme.md ? 'transform:  scaleX(-1)' : ''"
        @click="forwardAllMsg()"
      ></f7-link>
    </f7-toolbar>

    <AdaptiveSheet
      class="showReactionsPopover"
      swipe-to-close
      close-by-backdrop-click
      close-on-escape
      :backdrop="true"
      :style="{
        'min-height': !isTablet ? '300px !important' : 'auto',
        bottom: !isTablet ? 0 : '',
        top: !isTablet ? 'auto' : '',
        'max-height': isTablet ? 'auto' : '80%',
        height: isTablet ? '' : 'auto',
      }"
    >
      <f7-navbar :title="$t('common.reactions')">
        <f7-nav-right>
          <f7-link
            icon-ios="f7:plus_bubble"
            icon-md="material:add_circle"
            @click="openReactionEmojiPicker()"
          ></f7-link>
          <f7-link
            sheet-close
            popup-close
            icon-ios="f7:multiply"
            icon-md="material:close"
          ></f7-link>
        </f7-nav-right>
      </f7-navbar>
      <f7-page>
        <f7-toolbar tabbar scrollable top>
          <f7-link
            style="font-size: 16px"
            v-if="
              reactionMessage &&
              reactionMessage.reactions &&
              reactionMessage.reactions.length > 1
            "
            :text="
              reactionMessage.reactions.map((x) => x.emoji).join('') +
              '' +
              reactionMessage.reactions.reduce((sum, x) => sum + x.count, 0)
            "
            class="allReactions"
            tab-link="#id_allReactions"
            tab-link-active
          ></f7-link>
          <f7-link
            style="font-size: 16px"
            v-for="(reaction, index) in reactionMessage.reactions"
            :key="reaction.id"
            :text="reaction.emoji + '' + reaction.count"
            class="reactions"
            :tab-link="'#id_' + reaction.id"
          ></f7-link>
        </f7-toolbar>
        <f7-tabs>
          <f7-tab id="id_allReactions" tab-active>
            <f7-list media-list medium-inset>
              <f7-list-group>
                <span
                  v-for="(reaction, index) in reactionMessage.reactions"
                  :key="reaction.id"
                  :id="reaction.id"
                >
                  <f7-list-item
                    link="#"
                    v-for="user in reaction.authors"
                    :key="user.id"
                    :title="user.name"
                    :after="reaction.emoji"
                    @click="currentUsReaction(reactionMessage, reaction, user)"
                    :style="{
                      'background-color':
                        isOwnUserId(user.userId)
                          ? 'var(--f7-menu-list-item-bg-color)'
                          : 'auto',
                      'border-radius': '50px',
                    }"
                  >
                    <template #media>
                      <img
                        class="avocash-avatar-logo-img"
                        v-if="user.logo"
                        :src="user.logo"
                      />
                      <f7-badge
                        v-else
                        class="avocash-avatar-logo-badge"
                        color="auto"
                        >{{
                          $filtersGetInitial.getInitial(user.name)
                        }}</f7-badge
                      >
                    </template>
                  </f7-list-item>
                </span>
              </f7-list-group>
            </f7-list>
          </f7-tab>

          <f7-tab
            v-for="(reaction, index) in reactionMessage.reactions"
            :key="reaction.id"
            :id="'id_' + reaction.id"
          >
            <f7-list media-list medium-inset>
              <f7-list-item
                link="#"
                v-for="user in reaction.authors"
                :key="user.id"
                :title="user.name"
                :after="reaction.emoji"
                @click="currentUsReaction(reactionMessage, reaction, user)"
                :style="{
                  'background-color':
                    isOwnUserId(user.userId)
                      ? 'var(--f7-menu-list-item-bg-color)'
                      : 'auto',
                  'border-radius': '50px',
                }"
              >
                <template #media>
                  <img
                    class="avocash-avatar-logo-img"
                    v-if="user.logo"
                    :src="user.logo"
                  />
                  <f7-badge
                    v-else
                    class="avocash-avatar-logo-badge"
                    color="auto"
                    >{{ $filtersGetInitial.getInitial(user.name) }}</f7-badge
                  >
                </template>
              </f7-list-item>
            </f7-list>
          </f7-tab>
        </f7-tabs>
      </f7-page>
      <!-- </div> -->
    </AdaptiveSheet>

    <contactDetail
      v-if="group"
      :f7route="f7route"
      :f7router="f7router"
      :groupType="f7route.params.type"
      :chatGroupAdminList="chatGroupAdminList"
      :isGroupAdmin="isGroupAdmin"
      :commonGroups="commonGroups"
      :chatGroupParticipantList="chatGroupParticipantList"
    ></contactDetail>

    <messageActions
      :groupType="f7route.params.type"
      :currentMessage="currentMessage"
      @edit-message="handleEditMessage"
    ></messageActions>
    <transferMsg @transferred="handleTransferred"></transferMsg>
    <addParticipants
      v-if="group"
      :chatParticipantList="chatGroupParticipantList"
    ></addParticipants>
    <sendMsgPanel></sendMsgPanel>
    <AdaptiveSheet
      class="createNewPoll"
      style="--f7-sheet-bg-color: #fff"
      :tablet-fullscreen="false"
      backdrop
      :swipe-to-close="false"
      :close-by-backdrop-click="false"
      :close-on-escape="false"
      v-if="group"
    >
      <f7-page name="createNewPoll" hide-navbar-on-scroll>
        <f7-navbar sliding no-shadow>
          <f7-nav-title v-html="$t('poll.create')"></f7-nav-title>

          <f7-nav-right>
            <f7-link
              sheet-close=".createNewPoll"
              popup-close=".createNewPoll"
            >
              <f7-icon ios="f7:multiply" md="material:close"></f7-icon>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <AppLayout>
          <template #main>
            <pollCreate
              v-if="group"
              :currentEntity="group || null"
              ref="pollCreatePopup"
            />
          </template>
        </AppLayout>
      </f7-page>
    </AdaptiveSheet>
  </f7-page>
</template>
<style scoped>
.tamtamNav:hover,
#replyToMessage:hover {
  cursor: pointer;
}

.fab-button a {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.fab-buttons a {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.mainMessages .message-footer {
  margin: 0 auto;
}

.message-menu-icon,
.message-menu-reactIcon {
  visibility: collapse;
}

.messagebar-area .message {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
  margin: 0px 0px;
}

.messagebar-area .message .message-content {
  /* min-width: 100%; */
  width: 100%;
  /* max-width: 100%;
  margin: 0px 0px; */
}

.messagebar-area .message .message-text .message-name {
  display: inline-block;
}

.tamtamMessagePage .message:hover .popoverActionIcon .message-menu-icon,
.tamtamMessagePage .message:hover .popoverReactIcon .message-menu-reactIcon {
  /* display: inline-block;*/
  visibility: visible;
  color: gray;
}

.messageFileText {
  color: inherit;
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.message-received-reactions {
  margin-right: auto;
  margin-left: 48px;
}

.message-reactions-wrapper {
  width: 100%;
  display: flex;
  margin-top: 2px;
}

.message-reactions {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 12px;
  background: var(--f7-message-bg-color);
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  font-size: 13px;
}

.message-reactions.message-sent {
  margin-left: auto;
  margin-right: 0;
}

.message-reactions.message-received {
  margin-right: auto;
  margin-left: calc(8px + var(--f7-safe-area-left));
}

@media screen and (min-width: 1024px) {
  .view-master-detail .navbar-master-detail .navbar-inner a.link.back,
  .tamtamNav a.link.icon-only.back {
    display: none;
  }

  .navBarLeftImg {
    margin-left: 16px;
  }
}

.editInput {
  position: absolute;
  right: 0px;
  top: 8px;
  color: var(--f7-input-clear-button-color);
}

.recordBtn0 {
  position: absolute;
  right: 1rem;
  bottom: 0.25rem;
  background-color: #1d1d1d;
  border-radius: 50%;
}

.start {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: var(--f7-theme-color);
  box-shadow: none;
}

.recordBtn.stop {
  width: 2rem;
  height: 2rem;
  background-color: red;
  box-shadow: none;
  border-radius: 50%;
  margin-bottom: 16px;
  margin-right: 8px;
  animation: recordPulse 1.2s ease-in-out infinite;
}

@keyframes recordPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

.recording-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 6px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: red;
  white-space: nowrap;
}

.recording-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
  animation: recordingDot 1s ease-in-out infinite;
}

@keyframes recordingDot {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(0.8);
  }
}

.voiceMeter {
  position: absolute;
  background-color: var(--f7-card-bg-color, #fff);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  box-shadow: 3px 3px 10px #111;
}

.voiceMeterContainer {
  position: absolute;
  height: 2rem;
  width: 2rem;
  bottom: 0.25rem;
  right: 1rem;
}

:deep(.messagebar) {
  --f7-messagebar-attachment-height: 72px;
  --f7-messagebar-attachment-landscape-height: 72px;
}
.md .messagebar-attachment-delete, .messagebar-attachment-edit{
  z-index:1 !important;
}
.messagebar-attachment-edit{
   position: absolute;
    width: 24px;
    height: 24px;
    top: -24px;
    left: -14px;
    /* background-color:blue; */
    border-radius: 24px;
    border: 2px solid var(--f7-messagebar-textarea-bg-color);
        display: block;
    position: absolute;
    border-radius: 50%;
    box-sizing: border-box;
    cursor: pointer;
}
.messagebar-attachment video {
  display: block;
  border-radius: var(--f7-messagebar-attachment-border-radius);
}

.messagebar-attachments .messagebar-attachment {
  width: var(--f7-messagebar-attachment-height);
}

.messagebar-attachments .attachment-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
}

.messagebar-attachments .attachment-preview img,
.messagebar-attachments .attachment-preview video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.messagebar-attachments .attachment-preview .play-badge {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
}

.messagebar-attachments .attachment-preview--file {
  gap: 2px;
  padding: 6px 4px;
  background: rgba(127, 127, 127, 0.12);
}

.messagebar-attachments .attachment-preview .doc-icon,
.messagebar-attachments .attachment-preview .attachment-preview-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 0;
  flex: none;
  height: 22px;
}

.messagebar-attachments .attachment-preview .doc-icon :deep(.f7-icons),
.messagebar-attachments .attachment-preview .doc-icon :deep(.material-icons),
.messagebar-attachments .attachment-preview .attachment-preview-icon .f7-icons {
  font-size: 22px;
}

.messagebar-attachments .attachment-preview-name {
  max-width: 100%;
  font-size: 10px;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.messagebar-attachments .attachment-preview-size {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 9px;
  opacity: 0.6;
}

.messagebar-attachments.dropzone-container {
  border: 2px dashed transparent;
  transition: border-color 0.2s ease;
}

.messagebar-attachments.dropzone-container.is-dragging {
  border-color: var(--f7-theme-color);
}

.message-sent .message-bubble {
  background: var(--f7-color-lightblue, var(--f7-color-lightblue));
}
/* F7 v9 only flips the received-bubble bg for .ios.dark; the .md path
   references undefined --f7-md-surface-variant, so the bubble went
   transparent and blended into the dark page. Theme token fixes both modes. */
.message-received .message-bubble {
  background: var(--f7-surface-container-high, #e2eae1);
}
.selectedMsg--active {
  --f7-message-selected-bg-color: rgba(var(--f7-theme-color-rgb, 0, 9, 255), 0.15);
  background-color: var(--f7-message-selected-bg-color);
  border-radius: 12px;
  transition: background-color 0.15s ease;
}
.selectedMsg--active .message-bubble {
  background-color: var(--f7-message-selected-bg-color);
}
.interactionsIcons .list-button {
  padding-right: 4px;
}

.attachment-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 0px;
  padding-bottom: 16px;
}

.attachment-grid {
  display: grid;
  gap: 6px;
  width: 100%;
}

.attachment-grid--single {
  grid-template-columns: 1fr;
  max-width: 280px;
}

.attachment-grid--multi {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 330px;
}

.media-thumb {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  border-radius: 14px;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  min-width: 44px;
  min-height: 44px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.media-thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-video video{
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  border-radius: 14px;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  min-width: 44px;
  min-height: 44px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.media-more-indicator {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.media-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 44px;
  min-height: 44px;
  padding: 8px 12px;
  border: 0;
  border-radius: 14px;
  background: rgba(127, 127, 127, 0.12);
  text-align: left;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.media-document{
max-width:360px
}

.media-preview {
  position: relative;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
}

.media-preview-icon {
  color: #fff;
  font-size: 24px;
}

.play-badge {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
}

.media-preview--audio {
  background: rgba(127, 127, 127, 0.25);
  color: inherit;
}

.media-preview--audio .f7-icons {
  font-size: 24px;
}

.media-meta {
  flex: 1;
  min-width: 0;
}

.media-title {
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-subtitle {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  opacity: 0.7;
}

.doc-icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-width: 44px;
}

.doc-icon :deep(.f7-icons),
.doc-icon :deep(.material-icons) {
  font-size: 26px;
}

.download-hint {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  color: inherit;
  opacity: 0.7;
  font-size: 20px;
}

.reply-preview {
  display: flex;
  align-items: stretch;
  background: var(--f7-page-bg-color, #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
  min-height: 60px;
  position: relative;
}
.reply-preview-bar {
  width: 3px;
  flex-shrink: 0;
  background: var(--f7-theme-color);
  border-radius: 2px;
}
.reply-preview-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  min-width: 0;
  overflow: hidden;
}
.reply-preview-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.reply-preview-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--f7-theme-color);
  line-height: 1.3;
}
.reply-preview-text {
  font-size: 13px;
  color: var(--f7-text-color);
  opacity: 0.75;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.reply-preview-thumb {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  margin-left: 8px;
  background: rgba(127, 127, 127, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}
.reply-preview-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.reply-preview-close {
  position: absolute;
  /* right: 4px; */
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  right: -16px;
  top: 8px;
}
.reply-preview-close:hover {
  background: rgba(127, 127, 127, 0.15);
}

.edit-preview {
  display: flex;
  align-items: center;
  background: var(--f7-page-bg-color, #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 12px;
  gap: 8px;
  min-height: 44px;
}
.edit-preview-bar {
  width: 3px;
  flex-shrink: 0;
  height: 28px;
  background: var(--f7-theme-color);
  border-radius: 2px;
}
.edit-preview-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--f7-theme-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}
.edit-preview-text {
  font-size: 13px;
  color: var(--f7-text-color);
  opacity: 0.75;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
.edit-preview-close {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.edit-preview-close:hover {
  background: rgba(127, 127, 127, 0.15);
}

.mention-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  background: var(--f7-page-bg-color, #fff);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.mention-item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  gap: 10px;
  cursor: pointer;
}
.mention-item:hover,
.mention-item.mention-item-active {
  background: rgba(var(--f7-theme-color-rgb, 0, 124, 255), 0.1);
}
.mention-item-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: var(--f7-theme-color);
  overflow: hidden;
}
.mention-item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mention-item-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.mention-item-name {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mention-item-handle {
  font-size: 12px;
  opacity: 0.6;
}
.mention-bubble {
  color: var(--f7-theme-color);
  font-weight: 500;
}
</style>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue";
import { useLocationStore } from "../js/pinia-stores/location.js";
import { useMessageStore } from "../js/pinia-stores/message.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { closeAdaptiveModal } from "../js/composables/useAdaptiveModal.js";
import AdaptiveSheet from "../components/common/AdaptiveSheet.vue";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { theme, f7ready, f7 } from "framework7-vue";
import contactDetail from "../components/tamtam/contactDetail.vue";
import messageActions from "../components/tamtam/messageActions.vue";
import transferMsg from "../components/tamtam/transferMsg.vue";
import addParticipants from "../components/tamtam/addParticipants.vue";
import sendMsgPanel from "../components/tamtam/sendMsgPanel.vue";
import AppLayout from "../components/common/AppLayout.vue";
import pollCreate from "../components/pollCreate.vue";
import ChatFeedCard from "../components/tamtam/ChatFeedCard.vue";
import { useWebSocket } from "../js/composables/useWebSocket.js";
import {
  useMessageOptions,
} from "../js/composables/useMessage.js";
import { useAttachDocs } from "../js/composables/useAttachDocs.js";
import i18n from "../js/i18n.js";
const { t } = i18n.global;
import _ from "lodash";

// @ts-ignore
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
// @ts-ignore
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const CUSTOM_EMOJIS = [
  {
    id: "avocash",
    colons: ":avocash",
    name: "avocash",
    short_names: ["avocash"],
    keywords: ["avocash"],
    text: "avocash",
    custom: true,
    emoticons: [],
    imageUrl: "https://avocash.com/24x24.svg",
  },
];
const emojiIndex = new EmojiIndex(data, { custom: CUSTOM_EMOJIS });
const accountStore = useAccountStore();
const keycloakStore = useKeycloakStore();

// Store accessors
const profile = computed(() => useAuthStore().profile);
const isTablet = useTabletScreen().matches;
const documentsUrl = computed(() => useAuthStore().documentsUrl);
const userAccount = computed(() => useAccountStore().userAccount);
const country = computed(() => useLocationStore().country);
const messageList = computed(() => useMessageStore().messageList);
const group = computed(() => useMessageStore().group);
const groupList = computed(() => useMessageStore().groupList);
const counterPartUser = computed(() => useMessageStore().counterPartUser);
const infoMessage = computed(() => useMessageStore().infoMessage);
const messagesData = computed(() => useMessageStore().messagesData);
const replyMessage = computed(() => useMessageStore().replyMessage);
const typingMessage = computed(() => useMessageStore().typingMessage);
const msgCltConnected = computed(() => useMessageStore().msgCltConnected);
const messageSocketClient = computed(
  () => useMessageStore().messageSocketClient,
);
// Local state
const messagebarRef=ref(null);
const pollCreatePopup=ref(null);
const messages = ref(null);
const displayedMsg = ref(10);
const allowInfinite = ref(true);
const showPreloader = ref(false);
const imGattachments = ref([]);
const sheetVisible = ref(false);
const isOpenedReactionPopover = ref(false);
const isEmojiSheetVisible = ref(false);
const messageInScope = ref("");
const messageText = ref("");
const currentMessage = ref({});
const reactionMessage = ref("");
const timer = ref("");
const timeoutVal = ref(1000);
const isTypingMsg = ref("");
const showDialog = ref(false);
const emojisize = ref(30);
const getSet = ref("native");
const emojiIndexRef = ref(emojiIndex);
const responseInProgress = ref(false);
const i18n_locale = ref({});
const messagebar = ref(null);
const msgBarWidth = ref(0);
const messageIsSelected = computed(() => useMessageStore().messageIsSelected);
const selectedMessages = computed(() => useMessageStore().selectedMessages);
const transferMsgRecipients = ref([]);
const reactionEmoji = ref([]);
const chatUser = computed(() => useMessageStore().chatUser);

/**
 * Single source of truth for "is this message mine?". The template used to
 * compare `message.senderId === chatUser.userId` in a dozen places, which all
 * failed at once when `chatUser` had not loaded (or when the id came from a
 * different source than the Keycloak `sub`), so every bubble fell back to
 * "received". The store knows every id the signed-in user has.
 */
const isOwnMessage = (message) => useMessageStore().isOwnMessage(message);
const isOwnUserId = (userId) => useMessageStore().isOwnUserId(userId);
const currentUserId = computed(() => useMessageStore().currentUserId);
const currentSenderName = computed(() => useMessageStore().currentSenderName);

const editingMessage = ref(null);

const mentionQuery = ref(null);
const mentionActiveIndex = ref(0);
const mentionStartPos = ref(0);

const isGroupChat = computed(() => {
  const type = props.f7route.params.type;
  return type === "GROUP" || type === "SUBGROUP";
});

// Composables
let interactionSelectFn;
const messageOpts = useMessageOptions({
  isTablet,
  profile,
  userAccount,
  messageSocketClient,
  reactionEmoji,
  selectedMessages,
  messageIsSelected,
  currentMessage,
  messageInScope,
  transferMsgRecipients,
  chatUser,
  groupList,
  group,
  messageList,
  reactionMessage,
  isOpenedReactionPopover,
  onEditMessage: handleEditMessage,
  toogleDialogEmoji,
  interactionSelect: (emoji) => interactionSelectFn(emoji),
});
interactionSelectFn = messageOpts.interactionSelect;

const {
  openContactDetailPanel,
  openMsgActionsSheet,
  openMessageOpenActions,
  messageActions: handleMessageActions,
  replyMsg,
  replyMsgPrivately,
  deleteForMe,
  deleteSelectedMsg,
  deleteForAll,
  forwardAllMsg,
  selectMsg,
  selectMessage,
  clearSelection,
  copyMsg,
  forwardMsg,
  messageDeskTopActions,
  openMessageReactionPopover,
  interactionSelect,
  showMessageReactions,
  currentUsReaction,
} = messageOpts;

const {
  downloadFile,
  openFileWithFileOpener,
  isDragging,
  isRecording,
  startAudioRecording,
  stopAudioRecording,
  getFileMimeType,
  attachFileOpenActions,
  onPaste,
  onChange,
  dragover,
  dragleave,
  drop,
  editImage,
} = useAttachDocs({ isTablet });

const { connectMessageSocket, msgCltConnected: wsMsgCltConnected } =
  useWebSocket({ f7router: props.f7router });

const filteredMentionUsers = computed(() => {
  if (mentionQuery.value === null || !chatGroupParticipantList.value) return [];
  const q = mentionQuery.value.toLowerCase();
  return chatGroupParticipantList.value
    .filter((u) => {
      if (u.userId === profile.value?.sub) return false;
      return (
        (u.name && u.name.toLowerCase().includes(q)) ||
        (u.username && u.username.toLowerCase().includes(q)) ||
        (u.tag && u.tag.toLowerCase().includes(q)) ||
        (u.phoneNumber && u.phoneNumber.includes(q))
      );
    })
    .slice(0, 8);
});

function openReactionEmojiPicker() {
  closeAdaptiveModal(".showReactionsPopover");
  nextTick(() => {
    toogleDialogEmoji(true);
  });
}

function insertMention(user) {
  const displayName = user.name.split(" ")[0] || user.username || user.tag;
  const before = messageText.value.substring(0, mentionStartPos.value);
  const after = messageText.value.substring(
    mentionStartPos.value + 1 + (mentionQuery.value?.length || 0),
  );
  messageText.value = before + "@" + displayName + " " + after;
  mentionQuery.value = null;
  mentionActiveIndex.value = 0;
  nextTick(() => messagebar.value?.focus());
}

function handleMentionKeydown(e) {
  if (mentionQuery.value === null) return;
  if (filteredMentionUsers.value.length === 0) {
    mentionQuery.value = null;
    return;
  }
  if (e.key === "ArrowDown") {
    e.preventDefault();
    mentionActiveIndex.value = Math.min(
      mentionActiveIndex.value + 1,
      filteredMentionUsers.value.length - 1,
    );
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    mentionActiveIndex.value = Math.max(mentionActiveIndex.value - 1, 0);
  } else if (e.key === "Enter" && mentionQuery.value !== null) {
    e.preventDefault();
    insertMention(filteredMentionUsers.value[mentionActiveIndex.value]);
  } else if (e.key === "Escape") {
    mentionQuery.value = null;
  }
}

function detectMention(text) {
  if (!isGroupChat.value) {
    mentionQuery.value = null;
    return;
  }
  const el = messagebarRef.value?.$el?.querySelector("textarea, [contenteditable]");
  const cursorPos = el?.selectionStart ?? text.length;
  const textBeforeCursor = text.substring(0, cursorPos);
  const atMatch = textBeforeCursor.match(/@(\S*)$/);
  if (atMatch) {
    mentionQuery.value = atMatch[1];
    mentionStartPos.value = cursorPos - atMatch[0].length;
    mentionActiveIndex.value = 0;
  } else {
    mentionQuery.value = null;
  }
}

function renderMentions(text) {
  if (!text) return text;
  return text.replace(/@(\w+)/g, '<span class="mention-bubble">@$1</span>');
}

function handleEditMessage(message) {
  messageText.value = message.text?.replace(/<br\s*\/?>/gi, "\n") || "";
  editingMessage.value = message;
  nextTick(() => messagebar.value?.focus());
}

function acceptInvitation(message) {
  f7.dialog.alert(t('tamtammessage.invitationAccepted', { name: message.senderName }));
  console.log("Accept invitation:", message);
}

function rejectInvitation(message) {
  f7.dialog.alert(t('tamtammessage.invitationRejected', { name: message.senderName }));
  console.log("Reject invitation:", message);
}

function handleTapMessage(message, e) {
  if (!f7.device.desktop) return;
  
  if (editingMessage.value) {
    e?.preventDefault();
    return;
  }
  
  if (messageIsSelected.value) {
    e?.preventDefault();
    e?.stopPropagation();
    selectMessage(message);
    f7.taptic?.impact({ style: 'light' });
    return;
  }
}

function cancelEdit() {
  editingMessage.value = null;
  messageText.value = "";
  nextTick(() => messagebar.value?.focus());
}

function saveEdit() {
  const textContent = messageText.value.replace(/\n/g, "<br>").trim();
  if (!textContent.length) {
    cancelEdit();
    return;
  }
  useMessageStore().editMessage({
    message: editingMessage.value,
    newText: textContent,
  });
  editingMessage.value = null;
  messageText.value = "";
  sheetVisible.value = false;
  showDialog.value = false;
}

function isMessageEdited(message) {
  return message.updatedAt && message.sentAt && message.updatedAt !== message.sentAt;
}

watch(messageText, (val) => {
  detectMention(val);
});


// Voice recording UI state
const recordingDuration = ref(0);
let recordingTimer = null;
const formattedRecordingDuration = computed(() => {
  const minutes = Math.floor(recordingDuration.value / 60);
  const seconds = recordingDuration.value % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
});

watch(isRecording, (recording) => {
  if (recording) {
    recordingDuration.value = 0;
    recordingTimer = setInterval(() => {
      recordingDuration.value += 1;
    }, 1000);
  } else {
    if (recordingTimer) {
      clearInterval(recordingTimer);
      recordingTimer = null;
    }
    recordingDuration.value = 0;
  }
});

function toogleDialogEmoji(forReaction = false) {
  if (forReaction) {
    isOpenedReactionPopover.value = false;
    isEmojiSheetVisible.value = true;
  } else {
    isEmojiSheetVisible.value = false;
  }
  if (isTablet.value) {
    showDialog.value = !showDialog.value;
  } else {
    sheetVisible.value = !sheetVisible.value;
  }
  if (showDialog.value) {
    const msgBarToolWidth = f7.$(".messagebar .toolbar-inner").width();
    f7.$(".emoji-mart").css({
      "max-width": `${msgBarToolWidth}px`,
      "min-width": `${msgBarToolWidth}px`,
      width: `${msgBarToolWidth}px`,
    });
  }
}

function onSelectEmoji(emoji) {
  if (isEmojiSheetVisible.value) {
    isEmojiSheetVisible.value = false;
    sheetVisible.value = false;
    showDialog.value = false;
    interactionSelect(emoji);
  } else {
    messageText.value += emoji.native;
  }
  reactionEmoji.value = reactionEmojiList.value;
}

function scrollToMessage(messageId) {
  const msg = document.getElementById(`${messageId}`);
  if (msg) {
    msg.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }
}
function removeReplyMessage() {
  useMessageStore().replyMessage = {};
}

function loadMore() {
  if (!allowInfinite.value) return;
  allowInfinite.value = false;
  setTimeout(() => {
    if (messageList.value.length < displayedMsg.value) {
      showPreloader.value = false;
      return;
    }
    showPreloader.value = true;
    displayedMsg.value += 10;
    // if (messageSocketClient.value) {
      useMessageStore().getUserGroupMessages(
      {
          requestId: props.f7route.params.id,
          displayedMsg: displayedMsg.value,
        }
      );
    // }
    allowInfinite.value = true;
  }, 1000);
  showPreloader.value = false;
}

function messagePhotoBrowser(message) {
  if (!message.attachments || message.attachments.length === 0) {
    return;
  }
  const photos = message.attachments
    .map((item) => {
      if (item.fileType === "image") {
        return { url: item.url, caption: item.fileName, id: item.fileId };
      }
      if (item.fileType === "video") {
        return {
          html: `<video src="${item.url}" controls style="width: 100%; height: calc(100vh - var(--f7-navbar-height))" ></video>`,
          caption: item.fileName,
          id: item.fileId,
        };
      }
      if (item.fileType === "audio") {
        return {
          html: `<audio src="${item.url}" controls ></audio>`,
          caption: item.fileName,
          id: item.fileId,
        };
      }
      return item.contentType === "application/pdf" ? {
        html: `<iframe src="${item.url}" width="100%" height="100%"></iframe>`,
        caption: item.fileName,
        id: item.fileId,
      } : {
         html: `<iframe src="${item.url}" width="100%" height="100%"></iframe>`,
        caption: item.fileName,
        id: item.fileId,
      };
      return null;
    })
    .filter(Boolean);
  if (photos.length === 0) {
    return;
  }
  const photoBrowser = f7.photoBrowser.create({ photos });
  setTimeout(() => {
    photoBrowser?.open();
  }, 100);
}

function isFirstMessage(dayMessages, message, index) {
  const previousMessage = dayMessages[index - 1];
  if (message.isTitle) return false;
  if (
    !previousMessage ||
    previousMessage.type !== message.type ||
    previousMessage.senderName !== message.senderName
  )
    return true;
  return false;
}

function isLastMessage(dayMessages, message, index) {
  const nextMessage = dayMessages[index + 1];
  if (message.isTitle) return false;
  if (
    !nextMessage ||
    nextMessage.type !== message.type ||
    nextMessage.senderName !== message.senderName
  )
    return true;
  return false;
}

function deleteAttachment(image) {
  if (!image) return;
  const index = documentsUrl.value.indexOf(image);
  if (index > -1) documentsUrl.value.splice(index, 1);
  const index0 = imGattachments.value.indexOf(image);
  if (index0 > -1) imGattachments.value.splice(index0, 1);
  if (image.url && image.url.startsWith("blob:")) {
    window.URL.revokeObjectURL(image.url);
  }
}

function buildTypingMessage(typing) {
  const type = props.f7route.params.type;
  const senderName = currentSenderName.value;
  const isGroup = type !== "PERSONAL" && type !== "undefined";
  return isGroup
    ? {
        receiverId: group.value.id,
        groupType: group.value.groupType || type,
        senderId: currentUserId.value,
        groupId: group.value.id,
        name: senderName,
        typing,
      }
    : {
        receiverId: counterPartUser.value.userId,
        groupType: "PERSONAL",
        name: senderName,
        senderId: currentUserId.value,
        groupId: group.value.id,
        typing,
      };
}

function startTyping() {
  clearSelection();
  if (responseInProgress.value) return;
  responseInProgress.value = true;
  clearTimeout(timer.value);
  isTypingMsg.value = buildTypingMessage(true);
  if (!msgCltConnected.value) {
    connectMessageSocket();
  }
  messageSocketClient.value.send(
    "/app/message.typing",
    JSON.stringify(isTypingMsg.value),
  );
}

function stopTyping() {
  clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    isTypingMsg.value = buildTypingMessage(false);
    setTimeout(() => {
      messageSocketClient.value.send(
        "/app/message.typing",
        JSON.stringify(isTypingMsg.value),
      );
    }, 500);
    responseInProgress.value = false;
  }, timeoutVal.value);
}

function onMessagebarBlur() {
  stopTyping();
  setTimeout(() => {
    mentionQuery.value = null;
  }, 200);
}

/**
 * A transfer was published. When it went to exactly one conversation, open that
 * conversation: seeing the message land is the confirmation the sender wants.
 * Several destinations have no single conversation to show, so the list is
 * refreshed in place instead.
 */
function handleTransferred({ sent = [], failed = [], target = null } = {}) {
  if (sent.length === 0) return;
  if (!target || failed.length > 0) {
    useMessageStore().getUserGroups();
    return;
  }
  if (group.value?.id === target.chatGroupId) {
    useMessageStore().getUserGroups();
    return;
  }
  f7.views.main.router.navigate(
    `/message/${target.chatGroupId}/${target.groupType}`,
    { reloadAll: true }
  );
}

function sendMessage() {
  if (editingMessage.value) {
    saveEdit();
    return;
  }
  const type = props.f7route.params.type;
  const textContent = messageText.value.replace(/\n/g, "<br>").trim();
  const dt = new Date();
  if (!textContent.length && documentsUrl.value.length === 0) {
    messagebar.value?.clear();
    return;
  }
  const base = {
    text: textContent,
    senderId: currentUserId.value,
    senderName: currentSenderName.value,
    sentAt: dt.toISOString(),
    readAt: "",
    attachment: "",
    replyingTo: replyMessage.value?.id || "",
  };
  sheetVisible.value = false;
  showDialog.value = false;
  messageText.value = "";
  if (textContent.length) messagebar.value?.focus();

  let msg;
  if (
    group.value.groupType === "GROUP" ||
    group.value.groupType === "SUBGROUP" ||
    type === "GROUP" ||
    type === "SUBGROUP"
  ) {
    msg = {
      ...base,
      receiverId: group.value.id,
      receiverName: group.value.name,
      groupType: group.value.groupType || type,
      type: "",
      status: "sent",
      chatGroup: { id: group.value.id },
    };
  } else if (group.value.groupType === "PERSONAL" || type === "PERSONAL") {
    msg = {
      ...base,
      receiverId: counterPartUser.value.userId,
      receiverName: counterPartUser.value.name,
      groupType: group.value.groupType || "PERSONAL",
      type: "",
      status: "sent",
      chatGroup: { id: group.value.id },
    };
  } else if (infoMessage.value[0]?.status === "invite") {
    msg = {
      ...base,
      receiverId: counterPartUser.value.userId,
      receiverName: counterPartUser.value.name,
      groupType: "PERSONAL",
      type: "",
      status: "replyInvite",
      msgOrigin: "invitation",
      chatGroup: { id: counterPartUser.value.userId },
    };
  }
  if (msg) useMessageStore().sendChatMessage(msg);
  messagebar.value?.clear();
}

function imageAttachments(docs) {
  return (docs || []).filter((doc) => doc.fileType === "image");
}

function videoAttachments(docs) {
  return (docs || []).filter((doc) => doc.fileType === "video");
}

function audioAttachments(docs) {
  return (docs || []).filter((doc) => doc.fileType === "audio");
}

function documentAttachments(docs) {
  return (docs || []).filter(
    (doc) => !["image", "video", "audio"].includes(doc.fileType),
  );
}

function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

// Computed
const attachments = computed(() => documentsUrl.value);

const isInfoRoute = computed(() => props.f7route.params.type === "undefined");
const isGroupRoute = computed(() =>
  ["GROUP", "SUBGROUP"].includes(props.f7route.params.type),
);
const isPersonalRoute = computed(
  () => props.f7route.params.type === "PERSONAL",
);
const isTypedRoute = computed(() => props.f7route.params.type !== "undefined");

const showNavbar = computed(() =>
  isInfoRoute.value ? !!counterPartUser.value : isTypedRoute.value,
);

const navbarAvatarSrc = computed(() => {
  if (isInfoRoute.value || isPersonalRoute.value) {
    return counterPartUser.value?.avatar || null;
  }
  return group.value?.avatar || null;
});

const navbarAvatarInitial = computed(() => {
  if (isInfoRoute.value || isPersonalRoute.value) {
    return counterPartUser.value?.name;
  }
  return group.value?.name;
});

const navbarTitleName = computed(() => {
  if (isPersonalRoute.value && counterPartUser.value) {
    return (
      counterPartUser.value.name ||
      counterPartUser.value.username ||
      counterPartUser.value.phoneNumber
    );
  }
  if (isGroupRoute.value && group.value) return group.value.name;
  if (isInfoRoute.value && counterPartUser.value)
    return counterPartUser.value.name;
  return "";
});

const navbarShowBackLink = computed(
  () => f7.width < 768 || props.f7route.path.startsWith("/group/message"),
);

const chatGroupParticipantList = computed(() => {
  const type = props.f7route.params.type;
  if (type === "GROUP" && group.value?.groupParticipantList?.length > 0) {
    return group.value.groupParticipantList;
  } else if (
    type === "SUBGROUP" &&
    group.value?.subGroupParticipantList?.length > 0
  ) {
    return group.value.subGroupParticipantList;
  } else if (
    group.value?.groupParticipantList?.length > 0 &&
    type === "PERSONAL"
  ) {
    return group.value.groupParticipantList.find(
      (x) => x.userId !== profile.value.sub,
    );
  }
  return null;
});

const chatGroupUserList = computed(() => {
  const type = props.f7route.params.type;
  if (type !== "PERSONAL" && chatGroupParticipantList.value?.length > 0) {
    return chatGroupParticipantList.value
      .map((a) => a.name.split(" ")[0] || a.username || a.tag)
      .join(", ");
  } else if (
    type === "PERSONAL" &&
    group.value?.groupParticipantList?.length > 0
  ) {
    return group.value.groupParticipantList.find(
      (x) => x.userId !== profile.value.sub,
    );
  }
  return "";
});

const chatGroupAdminList = computed(() => {
  const type = props.f7route.params.type;
  if (type === "GROUP" && group.value?.groupAdminList?.length > 0) {
    return group.value.groupAdminList;
  } else if (
    type === "SUBGROUP" &&
    group.value?.subGroupAdminList?.length > 0
  ) {
    return group.value.subGroupAdminList;
  }
  return null;
});

const isGroupAdmin = computed(() => {
  if (chatGroupAdminList?.value?.length > 0) {
    return (
      _.find(chatGroupAdminList?.value, ["userId", profile?.value?.sub]) !== null
    );
  }
  return false;
});

const commonGroups = computed(() => {
  return _.intersectionBy(
    counterPartUser?.value?.userGroupList || [],
    chatUser.value?.userGroupList || [],
    "id",
  );
});

const attachmentsVisible = computed(() => {
  return attachments?.value.length > 0 || imGattachments?.value.length > 0;
});

const placeholder = computed(() => {
  if (
    !infoMessage.value ||
    (infoMessage.value && infoMessage.value.length == 0)
  ) {
    return attachments.value.length > 0 || imGattachments.value.length > 0
      ? t("tamtammessage.addCommentOrSend")
      : t("tamtammessage.typeamessage");
  } else {
    return infoMessage?.value[0]?.status === "invite"
      ? t("tamtammessage.writeaMessageToInvite", {
          myreceiver: infoMessage?.value[0]?.receiverName,
        })
      : t("tamtammessage.writeaMessageToReplyToInvite", {
          myreceiver: infoMessage?.value[0]?.receiverName,
        });
  }
});

const reactionEmojiList = computed(() => {
  const recentEmojis = emojiIndexRef.value._recentCategory?.emojis || [];
  const savedEmojis = window.__piniaLcStorage?.get?.("836nsyksl");
  let emojiList = [...recentEmojis, ...(savedEmojis ? savedEmojis : [])];
  if (emojiList.length === 0) {
    emojiList = [
      { id: "+1", native: "👍" },
      { id: "clap", native: "👏" },
      { id: "heart_hands", native: "🫶" },
      { id: "heart", native: "❤️" },
      { id: "bulb", native: "💡" },
      { id: "laughing", native: "😆" },
    ];
  }
  return emojiList;
});

// function initMessagesInstance() {
//   nextTick(() => {
//     if (messages.value && messages.value.$el) {
//       try {
//         f7.messages.create({
//           el: messages.value.$el,
//           autoLayout: true,
//           scrollMessages: true,
//         });
//       } catch (e) {
//         console.warn("Messages init deferred (non-fatal):", e);
//       }
//     }
//   });
// }

function resetMessages() {
  useMessageStore().messageList = [];
  useMessageStore().messagesData = [];
}

function loadGroupThread(source = 'auto') {
  const messageStore = useMessageStore();
  const routeId = props.f7route?.params?.id;
  const routeType = props.f7route?.params?.type;
  const storeGroupId = messageStore.group?.id;

  let groupId;
  let groupType;
  if (source === 'store' || (source === 'auto' && storeGroupId)) {
    groupId = storeGroupId;
    groupType = messageStore.group?.groupType;
  } else {
    groupId = routeId;
    groupType = routeType;
  }
  if (!groupId) {
    groupId = routeId;
    groupType = routeType;
  }

  const key = `${groupId}|${groupType}`;
  if (!groupId || messageStore._lastGroupKey === key) return;
  messageStore._lastGroupKey = key;

  resetMessages();
  messageStore
    .getGroupDetail({ requestId: groupId, groupType })
    .then(() => {
      setTimeout(() => {
        messageStore.getGroupParticipantList(groupId);
        messageStore.getUserGroupMessages({
          requestId: groupId,
          displayedMsg: displayedMsg.value,
        });
        if (
          groupType === "PERSONAL" &&
          group.value?.groupParticipantList?.length > 1
        ) {
          const counterUserId = group.value.groupParticipantList.find(
            (x) => x.userId !== profile.value.sub,
          )?.userId;
          if (counterUserId) {
            messageStore.getCounterPartUser(counterUserId);
          }
        } else if (groupType !== "PERSONAL") {
          messageStore.counterPartUser = {};
        }
      }, 300);
    })
    .catch((err) => {
      console.log(err);
    });
}

let routeWatchFirst = true;
watch(
  () => [props.f7route?.params?.id, props.f7route?.params?.type],
  () => {
    loadGroupThread(routeWatchFirst ? 'auto' : 'route');
    routeWatchFirst = false;
  },
  { immediate: true },
);

watch(
  () => useMessageStore().group?.id,
  () => {
    loadGroupThread('store');
  },
);

// watch(messagesData, (newVal) => {
//   if (newVal) initMessagesInstance();
// });

// watch(infoMessage, (newVal) => {
//   if (newVal && newVal.length > 0) initMessagesInstance();
// });

onMounted(() => {
  reactionEmoji.value = reactionEmojiList.value;

  // Resolve the signed-in id before anything is drawn: every bubble, avatar and
  // read receipt below depends on knowing which sender is "me".
  useMessageStore().ensureChatUser();

    f7ready(() => {
     if (messagebarRef.value) {
    messagebar.value = f7.messagebar.get(messagebarRef.value.$el);
  }
    });
    if (!msgCltConnected.value) {
      connectMessageSocket();
    }
    if(f7.panel.get(".contactDetailPanel")?.length > 0){
      f7.panel.close(".contactDetailPanel", true);
    }

    if (!country.value) {
      useLocationStore().getCountry();
    }

    msgBarWidth.value = f7.$(".messagebar .messagebar-area").width();
    f7.$("#replyToMessage").css({ width: `${msgBarWidth.value + 16}px` });
    if (f7.$("#replyToMessage")) {
      f7.$(".mainMessages").css({
        "margin-bottom": `${f7.$("#replyToMessage").height}px`,
      });
    }
    if (
      theme.md ||
      f7.device.firefox ||
      f7.device.android ||
      f7.device.androidChrome
    ) {
      getSet.value = "google";
    } else if (
      theme.ios ||
      theme.aurora ||
      f7.device.macos ||
      f7.device.iphone ||
      f7.device.ipad ||
      f7.device.ipod ||
      f7.device.ios
    ) {
      getSet.value = "apple";
    } else {
      getSet.value = "native";
    }

    i18n_locale.value = {
      search: t("emoji.search"),
      notfound: t("emoji.notfound"),
      categories: {
        search: t("emoji.searchResults"),
        recent: t("emoji.recent"),
        smileys: t("emoji.smileys"),
        people: t("emoji.people"),
        nature: t("emoji.nature"),
        foods: t("emoji.foods"),
        activity: t("emoji.activity"),
        places: t("emoji.places"),
        objects: t("emoji.objects"),
        symbols: t("emoji.symbols"),
        flags: t("emoji.flags"),
        custom: t("emoji.custom"),
      },
    };


    if (props.f7route?.params?.type === undefined && messageList.value.length >= 1) {
      resetMessages();
    }

    const root = document.documentElement;
    if (f7.width >= 768) {
      root.style.setProperty("--f7-panel-width", "418px");
      root.style.setProperty("--f7-panel-shadow", "none");
    } else {
      root.style.setProperty("--f7-panel-width", "100%");
      f7.$(".icon-checkbox").css("display", "none");
    }

    if (counterPartUser.value?.avatar === null) {
      f7.$(".message-avatar").css("display", "none");
    }

    loadGroupThread();

});

onBeforeUnmount(() => {
  clearTimeout(timer.value);
  if (recordingTimer) {
    clearInterval(recordingTimer);
    recordingTimer = null;
  }
  if (messageSocketClient.value && msgCltConnected.value) {
    const stopMsg = buildTypingMessage(false);
    try {
      messageSocketClient.value.send(
        "/app/message.typing",
        JSON.stringify(stopMsg),
      );
    } catch (e) {
      // socket may already be closed
    }
  }
});
</script>
